import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContractsService } from '../../../services/contracts.service';
import { ErrorService } from '../../../shared/services/error.service';
import { B2bContractDriver } from '../../../models/Contract';

@Component({
  selector: 'app-b2b-driver-documents',
  templateUrl: './b2b-driver-documents.component.html',
  styleUrls: ['./b2b-driver-documents.component.css']
})
export class B2bDriverDocumentsComponent {
  @Input() contractId: number | null = null;
  @Input() driverId: number | null = null;
  @Input() cnhDocumentUrl: string | null | undefined;
  @Input() termoResponsabilidadeUrl: string | null | undefined;
  @Input() canUpload = true;
  @Input() lockedMessage: string | null = null;

  @Output() documentsUpdated = new EventEmitter<B2bContractDriver>();

  readonly accept = '.pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png';
  uploadingType: 'CNH' | 'TermoResponsabilidade' | null = null;

  constructor(
    private contractsService: ContractsService,
    private errorService: ErrorService
  ) {}

  onFileSelected(event: Event, documentType: 'CNH' | 'TermoResponsabilidade'): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = '';
    if (!file) return;

    if (!this.contractId || !this.driverId) {
      this.errorService.showErrorMessage('Salve o condutor antes de enviar documentos.');
      return;
    }

    const allowed = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
    const extOk = /\.(pdf|jpe?g|png)$/i.test(file.name);
    if (!allowed.includes(file.type) && !extOk) {
      this.errorService.showErrorMessage('Formato não suportado. Use PDF, JPG ou PNG.');
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      this.errorService.showErrorMessage('Arquivo excede o limite de 10 MB.');
      return;
    }

    this.uploadingType = documentType;
    this.contractsService
      .uploadB2bDriverDocument(this.contractId, this.driverId, file, documentType)
      .subscribe({
        next: (driver) => {
          this.cnhDocumentUrl = driver.cnhDocumentUrl;
          this.termoResponsabilidadeUrl = driver.termoResponsabilidadeUrl;
          this.uploadingType = null;
          this.documentsUpdated.emit(driver);
        },
        error: () => {
          this.uploadingType = null;
        }
      });
  }
}
